import React, { useMemo, ComponentProps } from 'react'
import { useQuery } from 'convex/react'
import { api } from '@ppwr/convex/_generated/api'
import { ShowCards, ShowCardsProps } from '@/components/ANewDesign/BottomModalContent/Content/ShowCards/ShowCards'
import { useGameContext } from '../GameContext'
import { Doc } from '@ppwr/convex/_generated/dataModel'
import { DS } from '../../../design-system'
import { useGameBottomSheetStore } from './useGameBottomSheetStore'
import { useActiveFlowSchedule } from '../../../hooks/convex/useActiveFlowSchedule'
import { useGameState } from '../useGameState'

export type ShowCardsBottomSheetContentProps = ShowCardsProps

export const ShowCardsBottomSheetContent = (props: ShowCardsBottomSheetContentProps) => {
  // const { gameId } = useGameContext()
  const { isPaused, game } = useGameState()
  const { isWinnersReveal = false } = useActiveFlowSchedule(game?._id, isPaused) || {}
  if (!isWinnersReveal) {
    // TODO check back here (is it needed?) before merge.
    // || isPaused || !game)
    props.onClose()
  }

  return <ShowCards {...props} />
}
